import Button from '@mui/material/Button';
import { useSimpleFormIterator, useSimpleFormIteratorItem } from 'react-admin';
import AddExtraSmallIcon from '@/assets/icons/add-extra-small.svg?react';
import { IconButton } from '@mui/material';
import DeleteIcon from '@/assets/icons/delete-icon.svg?react';
import ArrowUpSmallIcon from '@/assets/icons/arrow-up-small.svg?react';
import ArrowDownSmallIcon from '@/assets/icons/arrow-down-small.svg?react';

export const AddButton = props => {
    const { add } = useSimpleFormIterator();

    return <SimpleFormButton onClick={() => add()} startIcon={<AddExtraSmallIcon />} props={props} />;
};

export const RemoveButton = ({ label }) => {
    const { remove } = useSimpleFormIteratorItem();
    return <SimpleFormIconButton onClick={() => remove()} icon={<DeleteIcon title={label} />} label={label} />;
};

export const UpButton = ({ label }) => {
    const { index, reOrder } = useSimpleFormIteratorItem();
    return <SimpleFormIconButton onClick={() => reOrder(index - 1)} icon={<ArrowUpSmallIcon title={label} />} label={label} disabled={index <= 0} />;
};

export const DownButton = ({ label }) => {
    const { index, total, reOrder } = useSimpleFormIteratorItem();
    return (
        <SimpleFormIconButton
            onClick={() => reOrder(index + 1)}
            icon={<ArrowDownSmallIcon title={label} />}
            label={label}
            disabled={total == null || index >= total - 1}
        />
    );
};

const SimpleFormButton = ({ onClick, startIcon, props }) => {
    return (
        <Button onClick={onClick} startIcon={startIcon} {...props} color='secondary' variant='contained'>
            {props.label}
        </Button>
    );
};

const SimpleFormIconButton = ({ onClick, icon, label, disabled = false }) => {
    return (
        <IconButton onClick={onClick} sx={{ padding: '12px' }} disabled={disabled} title={label} aria-label={label}>
            {icon}
        </IconButton>
    );
};
